// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import CONSTANTS from '../constants/telemetry';
import { EnvironmentType, IEnvironment } from './environmentType';

/**
 * This is the Production Environment. Used on the production server only.
 * */
export class ProductionEnvironment {
    static getConfiguration(): IEnvironment {
        return {
            aadClientIdForWebUser: '70039c9c-eb42-452c-bcdc-5aa65d164562',
            deployed: true,
            developerTelemetryKey: '66c1166c-4f85-4dee-8976-2d2e95047eeb',
            environmentType: EnvironmentType.Production,
            hostname: `${window.location.origin}`,
            name: 'PROD',
            oldRoboBaseUrl: 'https://robo.partners.extranet.microsoft.com',
            production: true,
            telemetryKey: '96fd5845-73a9-4f8c-97a3-ddeaa2ad2b51',
            telemetryUrl: CONSTANTS.telemetryUrl,
            isAutoUserOnboarding: true,
            graphApiDirectoryUrl: 'https://graph.microsoft.com/v1.0/directoryObjects',
            jarvisEmailCheck: true,
        };
    }
}
